// extracted by mini-css-extract-plugin
export var wrapper = "about-slider-module--wrapper--GKU87";
export var sliderImage = "about-slider-module--slider-image--zFIs0";